import { LoggedUser } from './LoggedUser'

export interface CognitoTokens {
  accessToken: string
  idToken: string
  refreshToken: string
}

export interface LoginSuccessResponse {
  token: CognitoTokens
  data: LoggedUser
  requiresMfaSetup?: boolean
}

export interface LoginMfaChallengeResponse {
  challenge: 'SOFTWARE_TOKEN_MFA'
  session: string
  username: string
}

export type LoginResponse = LoginSuccessResponse | LoginMfaChallengeResponse

export function isMfaChallengeResponse(response: LoginResponse): response is LoginMfaChallengeResponse {
  return 'challenge' in response && response.challenge === 'SOFTWARE_TOKEN_MFA'
}

export interface MfaSetupStartResponse {
  secretCode: string
  otpauthUrl: string
}

export interface MfaStatusResponse {
  enabled: boolean
}
